export const toDto = (data, fieldsMap) => {
    return Object.entries(data).reduce((acc, [name, _value]) => {
        const value = _value;
        const quizStepType = fieldsMap[name].quizStepType;
        if (quizStepType === 'rating') {
            const pairs = objectToKeyValueArray(value, name);
            for (const [fieldPath, value] of pairs) {
                acc.fields.push({
                    name: fieldPath,
                    value,
                    label: fieldsMap[name].label,
                });
            }
        }
        else {
            acc.fields.push({ name, value, label: fieldsMap[name].label });
        }
        return acc;
    }, { fields: [] });
};
function isObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function objectToKeyValueArray(obj, selfName) {
    const pairs = [];
    const queue = [{ current: obj, fieldPath: selfName }];
    while (queue.length > 0) {
        const item = queue.shift();
        if (item) {
            const { current, fieldPath } = item;
            for (const [key, value] of Object.entries(current)) {
                const fieldName = fieldPath ? `${fieldPath}.${key}` : key;
                if (isObject(value)) {
                    queue.push({ current: value, fieldPath: fieldName });
                }
                else {
                    pairs.push([fieldName, value]);
                }
            }
        }
    }
    pairs.sort(([fieldName1, _value1], [fieldName2, _value2]) => fieldName1.localeCompare(fieldName2));
    return pairs;
}
//# sourceMappingURL=to-dto.js.map